export default __webpack_public_path__ + "static/media/services_municipal_0.33be72f9.jpg";